// One-time, non-sensitive flag that survives the post-restore page reload so the
// reloaded app can confirm success. It carries no backup or financial data.
export const RESTORE_SUCCESS_MARKER_KEY = 'expense-assistant:restore-success';

export const RESTORE_SUCCESS_MESSAGE = 'Backup restored. Your workspace has been reloaded.';

export function markRestoreSuccess(): void {
  try {
    window.sessionStorage.setItem(RESTORE_SUCCESS_MARKER_KEY, '1');
  } catch {
    // Storage can be unavailable (private mode, blocked); the restore itself already succeeded.
  }
}

export function consumeRestoreSuccess(): boolean {
  try {
    const present = window.sessionStorage.getItem(RESTORE_SUCCESS_MARKER_KEY) !== null;
    if (present) window.sessionStorage.removeItem(RESTORE_SUCCESS_MARKER_KEY);
    return present;
  } catch {
    return false;
  }
}
